import { Controller } from "stimulus"
export default class extends Controller {
    //static targets = [ "service" ]

    //connect() {
    //    console.log("Connected! Rate....")
    //}

    submit(event) {

        if(document.querySelector('input[name="rate"]:checked') != null) {
          let formData = new FormData()
          formData.append("ratable", document.getElementById("ratable_service").value);
          formData.append("booking", document.getElementById("ratable_booking").value);
          formData.append("user", document.getElementById("user").value);

          if(typeof document.getElementById("user_tips").value !== 'undefined') {
            formData.append("tips", document.getElementById("user_tips").value);
          } else {
            formData.append("tips", "");
          }

          formData.append("stars", document.querySelector('input[name="rate"]:checked').value);
      
          fetch(this.data.get("update-url"), {
              body: formData,
              method: 'POST',
              credentials: "include",
              dataType: "script",
              headers: {
                      "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
              },
          })
          .then(response => response.text())
          .then(data => {
            $('#ask_feedback_interior')[0].innerHTML = data;
            setTimeout(function(){
              $('#ask_feedback').remove();
            }, 3000);          
          });
        } else {
          $('#ask_feedback').remove();
        }
    }

}
